
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class OrderCancellationRequestModel extends Model<OrderCancellationRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'comment', type: 'string', languageString: 'orderCancellationRequest.property.comment' },
		{ name: 'reasonId', type: 'guid', languageString: 'orderCancellationRequest.property.reasonId' }
	];
	[key: string]: any;
	
	public comment: string;
	public reasonId?: string;
    
	constructor(){
		super();
		this.comment = '';
		this.reasonId = undefined;
		
	}
	getProperties(){
		return OrderCancellationRequestModel.classProperties;
	}
}

